export default "__VITE_ASSET__90cefc38__"